import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

export type ScheduleToolbarButtonVariant = 'outline-secondary' | 'primary';

type ScheduleToolbarButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ScheduleToolbarButtonVariant;
  icon?: ReactNode;
  labelClassName?: string;
  shrink?: boolean;
  /** Accepted from react-bootstrap Dropdown.Toggle; ignored — sizing is fixed via btn-sm */
  size?: 'sm' | 'lg';
};

export const ScheduleToolbarButton = forwardRef<HTMLButtonElement, ScheduleToolbarButtonProps>(
  function ScheduleToolbarButton(
    {
      variant = 'outline-secondary',
      icon,
      children,
      className,
      labelClassName,
      shrink,
      type = 'button',
      size: _size,
      onClick,
      onPointerDown,
      ...rest
    },
    ref
  ) {
    const variantClass = variant === 'primary' ? 'btn-primary' : 'btn-outline-secondary';

    return (
      <button
        ref={ref}
        type={type}
        className={[
          'btn',
          'btn-sm',
          variantClass,
          'schedule-toolbar__btn',
          'd-flex',
          'align-items-center',
          'gap-1',
          shrink ? 'flex-shrink-0' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        onPointerDown={(e) => {
          onPointerDown?.(e);
        }}
        {...rest}
      >
        {icon}
        {children != null &&
          (labelClassName ? <span className={labelClassName}>{children}</span> : children)}
      </button>
    );
  }
);
